const images = {
  bg: require("../images/bg.jpeg"),
  logo: require("../images/logo.png"),
  ref: require("../images/ref.png"),
  meta: require("../images/meta.svg").default,
};
export default images;
